<ea-button
	(onClick)="resetForm()"
	name="{{ formName }}Clear"
	[type]="buttonType"
	>{{ btnText }}</ea-button
>
